module.exports = __webpack_public_path__ + "img/brush.275fadc8.svg";